import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79c9693d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-strength" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "password-strength-details"
}
const _hoisted_4 = { class: "password-strength-value" }
const _hoisted_5 = {
  key: 0,
  class: "info-box"
}
const _hoisted_6 = { class: "password-feedback" }

import { zxcvbn } from '@zxcvbn-ts/core'
  import {
    ComputedRef,
    Ref,
    computed,
    ref,
    onBeforeMount,
    toRefs,
    watch,
  } from 'vue'

  import { AUTH_USER_STORE, ROOT_STORE } from '@/store/constants'
  import { useStore } from '@/use/useStore'
  import { getPasswordStrength, setZxcvbnOptions } from '@/utils/password'

  interface Props {
    password: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    password: null
  },
  setup(__props: any) {

const props = __props as {
    password: string
  }

  
  const { password } = toRefs(props)

  const store = useStore()
  const language: ComputedRef<string> = computed(
    () => store.getters[ROOT_STORE.GETTERS.LANGUAGE]
  )
  const isSuccess: ComputedRef<boolean> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.IS_SUCCESS]
  )
  const passwordScore: Ref<number> = ref(0)
  const passwordStrength: Ref<string> = ref('')
  const passwordSuggestions: Ref<string[]> = ref([])
  const backgroundSize = ref('0% 100%')

  onBeforeMount(async () => await setZxcvbnOptions(language.value))

  function calculatePasswordStrength(password: string) {
    let zxcvbnResult = zxcvbn(password)
    passwordScore.value = zxcvbnResult.score
    passwordStrength.value = getPasswordStrength(passwordScore.value)
    passwordSuggestions.value = zxcvbnResult.feedback.suggestions
    backgroundSize.value = (passwordScore.value * 100) / 4 + '% 100%'
  }

  watch(
    () => language.value,
    async (newLanguageValue) => {
      await setZxcvbnOptions(newLanguageValue)
    }
  )
  watch(
    () => password.value,
    async (newPassword) => {
      if (isSuccess.value) {
        passwordStrength.value = ''
      } else {
        calculatePasswordStrength(newPassword)
      }
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: _normalizeClass(["password-slider", `strength-${passwordScore.value}`]),
      style: _normalizeStyle({ backgroundSize: backgroundSize.value }),
      type: "range",
      value: passwordScore.value,
      min: "0",
      max: "4",
      step: "1"
    }, null, 14, _hoisted_2),
    (passwordStrength.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('user.PASSWORD_STRENGTH.LABEL')) + ": " + _toDisplayString(_ctx.$t(`user.PASSWORD_STRENGTH.${passwordStrength.value}`)), 1),
          (passwordSuggestions.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(passwordSuggestions.value, (suggestion) => {
                    return (_openBlock(), _createElementBlock("li", { key: suggestion }, _toDisplayString(_ctx.$t(`user.PASSWORD_STRENGTH.SUGGESTIONS.${suggestion}`)), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})